/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

const compose = require('../../vendor/koa-compose.es6');

/**
 *
 * @param Array<GeneratorFunction> middleware
 */
export default function iterateOverGenerator(middleware) {

    let iterator = compose(middleware)();

    function iterate(value) {
        let iteration;

        if (value) {
            iteration = value.next();
        } else {
            iteration = iterator.next();
        }

        if (!iteration.done) {
            if ('then' in iteration.value) {
                iteration.value.then(function iterateGenerator() {
                    iterator.next();
                });
            } else {
                iterate(iteration.value);
            }
        }
    }

    setTimeout(iterate, 0);
}



/** WEBPACK FOOTER **
 ** ./lib/router/iterateOverGenerator.es6.js
 **/